export default __webpack_public_path__ + "static/media/icon-brasil.46c5ea65.svg";